import { AgelessAssessmentUsageContext } from "@orval/model";

import type { AssessmentUsageContextCapabilities } from "./assessmentUsageContext.types";

const STANDARD_CAPABILITIES: AssessmentUsageContextCapabilities = {
  showConsultCtas: true,
  useSalesCopy: true,
  assumeInServiceArea: false,
};

const AT_PRACTICE_CAPABILITIES: AssessmentUsageContextCapabilities = {
  showConsultCtas: false,
  useSalesCopy: false,
  assumeInServiceArea: true,
};

export function getCapabilitiesForUsageContext(
  usageContext: AgelessAssessmentUsageContext,
): AssessmentUsageContextCapabilities {
  switch (usageContext) {
    case AgelessAssessmentUsageContext.Standard:
      return STANDARD_CAPABILITIES;
    // In Clinic and In-Consult are both at-practice sessions: consult CTAs and
    // sales copy off, patient treated as in the service area by default.
    case AgelessAssessmentUsageContext.InClinic:
    case AgelessAssessmentUsageContext.Consult:
      return AT_PRACTICE_CAPABILITIES;
    case AgelessAssessmentUsageContext.WebsiteEmbed:
      return STANDARD_CAPABILITIES;
  }
}
